module.exports = __webpack_public_path__ + "img/storage43.7328cc02.jpg";